import React, { Suspense, lazy, FC } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { FallbackView } from '../../_metronic/partials'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import HasPermission from '../pages/permissionsGate/HasPermission'
import PermissionsRouteGate from '../pages/permissionsGate/PermissionsRouteGate'
import ReportRoute from '../pages/report/ReportRoute'

export function PrivateRoutes() {

  const IntentsPageWrapper = lazy(() => import('../pages/Intents/IntentsPageWrapper'))
  const CreateIntentPage = lazy(() => import('../pages/Intents/CreateIntentPage'))
  const EditIntentPage = lazy(() => import('../pages/Intents/EditIntentPageNew'))
  const SettingPage = lazy(() => import('../pages/setting/SettingPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const FallbackPage = lazy(() => import('../pages/fallbacks/FallbackPage'))
  const FallbackFormPage = lazy(() => import('../pages/fallbacks/FallbackFormPage'))
  const PollPageWrapper = lazy(() => import('../pages/poll/PollPageWrapper'))
  const CreatePollPage = lazy(() => import('../pages/poll/CreatePollPage'))
  const EditPollPage = lazy(() => import('../pages/poll/EditPollPage'))

  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>

        <Route path='/dashboard' component={DashboardWrapper} />
        <Route
          path="/apps/chat"
          render={() =>
            <PermissionsRouteGate pageName="chat" scopes={['view']}>
              <ChatPage />
            </PermissionsRouteGate>
          }
        />
        <Route
          path="/intents/create"
          render={() =>
            <PermissionsRouteGate pageName="intent" scopes={['add']}>
              <CreateIntentPage />
            </PermissionsRouteGate>
          }
        />
        <Route
          path="/intents/edit/:intentId/:locale"
          render={() =>
            <PermissionsRouteGate pageName="intent" scopes={['edit']}>
              <EditIntentPage />
            </PermissionsRouteGate>
          }
        />
        <Route
          path="/intents/edit/:intentId"
          render={() =>
            <PermissionsRouteGate pageName="intent" scopes={['edit']}>
              <EditIntentPage />
            </PermissionsRouteGate>
          }
        />
        <Route
          path="/intents"
          render={() =>
            <PermissionsRouteGate pageName="intent" scopes={['view']}>
              <IntentsPageWrapper />
            </PermissionsRouteGate>
          }
        />
        <Route
          path="/setting"
          render={() =>
            <PermissionsRouteGate pageName="setting" scopes={['edit']}>
              <SettingPage />
            </PermissionsRouteGate>
          }
        />
        <Route
          path="/false-message/:id"
          render={() =>
            <PermissionsRouteGate pageName="fallback" scopes={['edit']}>
              <FallbackFormPage />
            </PermissionsRouteGate>
          }
        />
        <Route
          path="/false-message"
          render={() =>
            <PermissionsRouteGate pageName="fallback" scopes={['view']}>
              <FallbackPage />
            </PermissionsRouteGate>
          }
        />
        <Route path="/report" component={ReportRoute} />
        <Route path="/poll/create" component={CreatePollPage} />
        <Route path="/poll/edit/:pollId" component={EditPollPage} />
        <Route path="/poll" component={PollPageWrapper} />
        <Redirect from='/auth' to='/dashboard' />
        <Redirect exact from='/' to='/dashboard' />
        <Redirect to='/error/404' />
      </Switch>
    </Suspense>
  )
}
